import { NilGoSubmissionForm as SharedNilGoSubmissionForm } from '@adthlete/shared-frontend'

interface Props {
  campaign: any
  onSave: (nilGoFields: Record<string, string>) => Promise<void>
}

const NilGoSubmissionForm = ({ campaign, onSave }: Props) => {
  return (
    <SharedNilGoSubmissionForm
      nilGoFields={campaign.nilGoFields}
      brandName={campaign.brand?.name}
      paymentAmount={campaign.payout}
      platform={campaign.platform}
      dealExecutedAt={campaign.dealExecutedAt ?? campaign.startDate}
      endDate={campaign.endDate}
      contentDueDate={campaign.contentDueDate}
      instructions={campaign.instructions}
      onSave={onSave}
      saveLabel="Save Fields"
      showOpenNilGo={true}
    />
  )
}

export default NilGoSubmissionForm
